<template>
  <a-drawer
    :title="labels.title.replace('{email}', user?.email)"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
    :width="isMobile ? '100%' : 600"
  >
    <ValidationObserver ref="observer">
      <a-form
        :label-width="80"
        slot-scope="{ validate }"
        @submit.prevent="validate().then(handleSubmit)"
      >
        <a-row type="flex" justify="center" :gutter="[0, 0]">
          <a-col :span="24">
            <InputValidation
              vid="subject"
              type="text"
              rules="required"
              v-model="form.subject"
              :label="labels.form.subject.label"
              :placeholder="labels.form.subject.placeholder"
              :allowClear="true"
            />
          </a-col>
          <a-col :span="24">
            <a-form-item :label="labels.form.message.label">
              <wysiwyg
                vid="message"
                type="text"
                rules="required"
                v-model="form.message"
                :minHeight="600"
                :placeholder="labels.form.message.placeholder"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row type="flex" justify="center">
          <a-col>
            <a-button-group>
              <a-button type="danger" :loading="submitting" @click="onClose">{{
                labels.form.cancel
              }}</a-button>
              <a-button
                type="primary"
                :loading="submitting"
                @click="validate().then(handleSubmit)"
                >{{ labels.form.send }}</a-button
              >
            </a-button-group>
          </a-col>
        </a-row>
      </a-form>
    </ValidationObserver>
  </a-drawer>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import InputValidation from "../../../components/core/VeeValidateForm/Input.vue";
import { DATE_FORMAT } from "../../../utils/utils";
import { mapState, mapActions } from "vuex";
import _ from "lodash";

const initialFormState = {
  subject: "",
  message: "",
};

export default {
  name: "NotificationForm",
  components: {
    ValidationObserver,
    InputValidation,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    labels: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      submitting: false,
      form: _.cloneDeep(initialFormState),
    };
  },
  methods: {
    ...mapActions("notifications", ["sendNotification"]),
    async handleSubmit() {
      if (this.submitting || !this.validateForm()) return;
      this.submitting = true;
      try {
        const message = {
          users: this.user.id.toString(),
          subject: this.form.subject,
          data: {
            message: this.form.message,
          },
          options: {
            link: location.origin + "/notifications",
          },
        };
        await this.sendNotification(message);
        this.resetForm();
        this.onClose();
        this.$message.success(this.labels.form.success);
      } catch (error) {
        this.$message.error(this.labels.form.error);
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.form = _.cloneDeep(initialFormState);
      this.$refs.observer?.reset();
    },
    validateForm() {
      if (!this.form.message) {
        this.$message.error(this.labels.form.message.required);
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState("layout", ["screenWidth"]),
    dateFormat() {
      return DATE_FORMAT.MOMENT_DATE;
    },
    isMobile() {
      return this.screenWidth < 600;
    },
  },
};
</script>
